import * as validator from 'utils/validators/validators'

export function validateCPForCNPJ(value: string): string | boolean {
  const strippedValue = validator.stripCnpj(value)

  if (strippedValue.length === 11) {
    return validator.isCpf(strippedValue) || 'CPF inválido'
  }

  if (strippedValue.length > 11) {
    return validator.isCnpj(strippedValue) || 'CNPJ inválido'
  }

  return true
}
